import { useState } from 'react';
import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import {
  Button,
  Banner,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { FileDescriptionIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import { FileUploader } from '@fortress-technology-solutions/fortress-component-library/Molecules';

const UploadApplicationModal = ({ open, onClose, onUploadApplication }) => {
  const [file, setFile] = useState(null);

  const handleFileChange = (file) => {
    setFile(file);
  };

  const handleUploadApplication = () => {
    if (!file) return;

    onUploadApplication?.(file);
  };

  return (
    <Modal
      title="Upload Application"
      icon={<FileDescriptionIcon />}
      open={open}
      actions={
        <>
          <Button variant="text" color="primary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleUploadApplication}
            disabled={!file}
          >
            Save
          </Button>
        </>
      }
      ModalProps={{
        PaperProps: {
          sx: {
            maxWidth: '450px',
          },
        },
      }}
    >
      <Banner
        status="info"
        message="Once you upload and save the file, it will automatically appear under the household’s documents."
      />
      <FileUploader
        sx={{
          width: '100%',
          maxWidth: '100%',
          marginTop: 2,
        }}
        requiredFileType="application/pdf"
        onChange={handleFileChange}
      />
      <Typography variant="bodySmall" color="text.disabled">
        Document type must be a PDF
      </Typography>
    </Modal>
  );
};

export default UploadApplicationModal;
